import api from '@common/api';
import { InvestorAccount, Trade } from '@services/appsync/types';
import { createStore, useStore } from 'zustand';
import { persist } from 'zustand/middleware';

interface TradesModelProps {
  trades?: Trade[];
}
interface TradesModelActions {
  fetchTrades: (investorAccount: InvestorAccount) => Promise<Trade[] | null>;
  setTrades: (trades: Trade[]) => void;
}

export const TradesModel = createStore(
  persist<TradesModelProps & TradesModelActions>(
    (set) => ({
      fetchTrades: async (investorAccount) => {
        const trades = await api.allTrades({
          investor_account_id: investorAccount.id,
        });
        if (trades) set({ trades });
        return trades ? trades : null;
      },
      setTrades: (trades) => {
        set({ trades });
      },
    }),
    {
      getStorage: () => localStorage,
      name: 'trades-model',
    },
  ),
);

export function useTradesModel(): TradesModelProps & TradesModelActions;
export function useTradesModel<T>(
  selector: (state: TradesModelProps & TradesModelActions) => T,
  equals?: (a: T, b: T) => boolean,
): T;
export function useTradesModel<T>(
  selector?: (state: TradesModelProps & TradesModelActions) => T,
  equals?: (a: T, b: T) => boolean,
) {
  // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  return useStore(TradesModel, selector!, equals);
}
